import VisitStats from './VisitStats.component';

export default VisitStats;